import * as React from 'react';
const initial = {
  visible: false,
  index: -1,
  itemsRefs: [],
  referenceElement: null,
  dispatch: () => {}
};
export default /*#__PURE__*/React.createContext(initial);